module.exports = __webpack_public_path__ + "img/hero-getting-started-mobile.0e6b2dd3.png";